import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { HotToastService } from "@ngneat/hot-toast";
import * as Sentry from "@sentry/angular";
import { environment } from "../../../environments/environment";
import { ErrorToastComponent } from "../components/error-toast/error-toast.component";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const originalError = error?.rejection ?? error;

    // Ignore NgbModal dismiss reasons (BACKDROP_CLICK = 0, ESC = 1)
    if (originalError === 0 || originalError === 1) {
      return;
    }

    // Only handle HTTP errors with toast — other errors are logged to Sentry silently
    if (originalError instanceof HttpErrorResponse) {
      if (originalError.status === 0) {
        return;
      }
      this.handleHttpError(originalError);
    } else {
      // Non-HTTP errors: log to Sentry in production, console in dev
      if (environment.production) {
        Sentry.captureException(originalError);
      } else {
        console.error(originalError);
        throw error;
      }
    }
  }

  private handleHttpError(err: HttpErrorResponse): void {
    if (environment.production) {
      const sentryContext = (err as any)?.__sentryContext;

      Sentry.withScope((scope) => {
        if (sentryContext) {
          scope.setFingerprint(sentryContext.fingerprint);
          scope.setContext("backend_details", sentryContext.backendDetails);
          scope.setContext("request_details", sentryContext.requestDetails);
        }
        console.log(sentryContext.backendDetails);
        const errorMessage = `API ${err.status} Error: ${err.url}`;
        const eventId = Sentry.captureException(new Error(errorMessage));
        const shortId = eventId.substring(0, 8).toUpperCase();

        try {
          const toast = this.injector.get(HotToastService);
          toast.show(ErrorToastComponent, {
            data: { eventId, shortId },
            id: shortId,
            icon: "❌",
            position: "top-right",
            duration: 10000,
          });
        } catch {
          console.error("Global error:", err);
        }
      });
    } else {
      console.error(err);
      const sentryContext = (err as any)?.__sentryContext;
      console.log(sentryContext.backendDetails);
      console.log(sentryContext.requestDetails);
      try {
        const toast = this.injector.get(HotToastService);
        toast.error(`Er ging iets mis: HTTP ${err.status}: ${err.message}`);
      } catch {
        // Toast service not available during bootstrap
      }
    }
  }
}
